import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { FC, useEffect, useState } from "react";
import { Clp } from "../../../../../../models/Clp";
import { withStyles } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import ChecklistAccordionDetails from "./ChecklistAccordionDetails";
import ChecklistAccordionSummary from "./ChecklistAccordionSummary";

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(255, 255, 255, 0.1)',
    background: 'rgb(23,32,45)',
    "&$expanded": {
      margin: "16px 0 !important"
    },
  },
  expanded: {},
})(MuiAccordion);

const useStyles = makeStyles({
  accordionWrapper: {
    margin: '16px 0'
  },
  accordionSummaryContent: {
    margin: 0,
  },
  accordionSummaryRoot: {
    // minHeight: '41px',
    backgroundColor: 'rgb(23,32,45) !important',
  },
  accordionDetailsRoot: {
    padding: '5px 5px 10px'
  },
  icon: {
    color: 'rgba(194, 201, 209, 1)'
  }
})

type PropsType = {
  clps: Clp[]
  selectedTab: number
  onUpdateChecklist: (id: string, index: number) => void
}

const ChecklistAccordion: FC<PropsType> = ({clps, selectedTab, onUpdateChecklist}) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState<{ state: Array<boolean> }>(
    {state: Array(clps.length).fill(false)}
  )

  useEffect(() => {
    setExpanded({
      ...expanded,
      state: Array(clps.length).fill(false)
    })
  }, [selectedTab])

  const handlerExpanded = (index: number): void => {
    const newStateExpanded = expanded.state
    newStateExpanded[index] = !newStateExpanded[index]
    setExpanded({ ...expanded, state: newStateExpanded })
  }

  return (
    <div className={classes.accordionWrapper}>
      {clps.map((clp, index) => {
        return (
          <Accordion
            expanded={expanded.state[index] || false}
            onChange={() => handlerExpanded(index)}
            key={index}
          >
            <AccordionSummary
              classes={{
                root: classes.accordionSummaryRoot,
                content: classes.accordionSummaryContent
            }}
              expandIcon={<ExpandMoreIcon className={classes.icon} />}
              aria-controls={`panel${index + 1}a-content`}
              id={`panel${index}a-header`}
              key={index}
            >
              <ChecklistAccordionSummary
                id={clp.id}
                index={index}
                title={clp.q_title}
                isDone={clp.is_done}
                isMandatory={clp.is_mandatory}
                updatedBy={clp.updated_by}
                updatedAt={clp.updated_at}
                onUpdateChecklist={onUpdateChecklist}
              />
            </AccordionSummary>
            <AccordionDetails classes={{root: classes.accordionDetailsRoot}}>
              <ChecklistAccordionDetails
                images={clp.images}
                description={clp.description}
              />
            </AccordionDetails>
          </Accordion>
        )})
      }
    </div>
  )
}

export default ChecklistAccordion
